import { createFileRoute } from "@tanstack/react-router";
import AboutPage from "@/features/public/pages/about";

export const Route = createFileRoute("/(public)/_public/about")({
  component: AboutPage,
});
